<template>
  <v-container fluid class="px-1 py-1">
    <CommonTable
        title="Part number"
        :embedded="embedded"
        :height="height"
        :dto-list-query="dtoListQuery"
        :dto-detail-query="dtoDetailQuery"
        :dto-action-command="dtoActionCommand"
        :store-name="storeName"
        :detail-store-name="detailStoreName"
        detailComponentPass="/CoreComponent/PartNumber/PartNumberDetail"
        :parent-component="$options.name"
    >
      <template v-slot:bar>
        <slot name="bar"></slot>
      </template>
      <template v-slot:top>
        <slot name="top"></slot>
      </template>
      <template v-slot:top.bar.filter>
        <slot name="top.bar.filter"></slot>
      </template>
      <template v-slot:item.provider__name="{ item }">
        <span v-if="!!item.provider_uid && !!storeAggregate.rootData[item.provider_uid]">
          {{storeAggregate.rootData[item.provider_uid].name}}
        </span>
      </template>
      <template v-slot:item.component__article_display="{ item }">
        <span v-if="!!item.component_uid && !!storeAggregate.rootData[item.component_uid]">
          {{storeAggregate.rootData[item.component_uid].article_display}}
        </span>
      </template>
      <template v-slot:item.component="{ item }">
        <span v-if="!!item.component_uid && !!storeAggregate.rootData[item.component_uid]">
          {{storeAggregate.rootData[item.component_uid].alias}}
        </span>
      </template>
      <template v-slot:footer.prepend>
        <slot name="footer.prepend"></slot>
      </template>
    </CommonTable>
  </v-container>
</template>

<script>
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useTableStore} from "@/components/Common/CommonTable";
import CommonTable from "@/components/Common/CommonTable";
import {v4 as uuidv4} from "uuid";

export default {
  name: "PartNumberTable",

  props: {
    embedded: {default: false},
    headers: {default: null},
    height: {default: null},
    storeName: {type: [String], default() {return uuidv4()}},
    dtoDetailQuery: {default: 'PartNumberDetailQueryDTO'},
    detailStoreName: {type: [String], default() {return uuidv4()}},
    dtoListQuery: {type: [String], default: 'PartNumberListQueryDTO'},
    dtoActionCommand: {type: [String], default: 'PartNumberActionCommandDTO'},
    mainValidator: {type: [Boolean], default: false},
  },

  components: {
    CommonTable,
    PartNumberDetail: () => import("@/components/CoreComponent/PartNumber/PartNumberDetail"),
  },

  methods: {
  },


  mounted() {
    this.storeTable = useTableStore(this.storeName)()
    this.storeTable.headers = this.headers || [
      {text: 'E', value: 'edit', sortable: false, filterable: true, divider: true, width: 30},
      // {text: 'uid', value: 'uid', sortable: true, filterable: true, divider: true, width: 300},
      {text: 'Provider', value: 'provider__name', sortable: true, filterable: true, divider: true},
      {text: 'P/N', value: 'part_number', sortable: true, filterable: true, divider: true},
      {text: 'Article', value: 'component__article_display', sortable: true, filterable: true, divider: true},
      {text: 'Component', value: 'component', sortable: true, filterable: true, divider: true},
      {text: 'version', value: 'version', sortable: true, filterable: true, divider: true, width: 100},
      {text: 'edited_by', value: 'edited_by_uid', sortable: true, filterable: true, divider: true},
      {text: 'edited_on', value: 'edited_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
      {text: 'created_by', value: 'created_by_uid', sortable: true, filterable: true, divider: true},
      {text: 'created_on', value: 'created_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
      {text: '', value: 'is_saved', sortable: false, filterable: true, divider: true, width: 30},
    ]
    this.storeAggregate = useAggregateStore()
    if (!!this.storeTable) {
      this.storeTable.dtoDetailQuery = this.dtoDetailQuery
      this.storeTable.dtoListQuery = this.dtoListQuery
      this.storeTable.dtoActionCommand = this.dtoActionCommand
      this.storeTable.options.sortBy = ['provider__name', 'part_number']
      this.storeTable.options.sortDesc = [true, true]
      this.storeTable.options.multiSort = false
    }
  },

  data() {
    return {
      storeTable: null,
    }
  },
}
</script>

<style scoped>

</style>